export { Footnote1, Footnote2 } from '@sberdevices/plasma-core';
